var _defs, _path, _path2, _polygon, _path3, _rect, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Concrete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "NY3BQxNIKewAc7Hyf_lWka",
    x1: -1.624,
    x2: 22.667,
    y1: 2.989,
    y2: 27.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8795a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d7882"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#NY3BQxNIKewAc7Hyf_lWka)",
    d: "M45.963,39.618,39.741,10.62056a2.00091,2.00091,0,0,0-1.964-1.618H10.223a1.999,1.999,0,0,0-1.963,1.618L2.038,39.618A1.99929,1.99929,0,0,0,4.001,42H44A2.0003,2.0003,0,0,0,45.963,39.618Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed6c47",
    d: "M30,38H46a0,0,0,0,1,0,0v2a2,2,0,0,1-2,2H30a0,0,0,0,1,0,0V38A0,0,0,0,1,30,38Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#889097",
    points: "24 9 30 42 30 38 24 5 24 9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff8f6b",
    d: "M46,38H30L24,5H36.9a1.9921,1.9921,0,0,1,1.95,1.56L40.54,14,41,16l2.04,9,.46,2Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 4,
    x: 30,
    y: 38,
    fill: "#889097"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#bfc8d1",
    points: "43.5 27 43.04 25 32.439 25 30.667 16 41 16 40.54 14 30.273 14 28.5 5 24 5 30 38 35 38 32.833 27 43.5 27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Concrete);
export default __webpack_public_path__ + "static/media/icons8-concrete.a9379ccb5249ba5eb75078cdafa2ba54.svg";
export { ForwardRef as ReactComponent };